module.exports = __webpack_public_path__ + "img/close_search.173a4156.svg";